import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorSection } from 'src/components/sections/ErrorSection';
import { Button } from 'src/components/ui/button';
import { useLogout } from 'src/hooks/useLogout';
import { useUser } from 'src/hooks/useUser';
import { ACCESS_DEMAND_PLANNING_ROLE } from 'src/keys';
import { BrandSidebarWithHeader } from 'src/layouts/BrandSidebarWithHeader';

type AccessGuardProps = { children: ReactElement };

export function AccessGuard({ children }: AccessGuardProps): ReactElement {
  const { user } = useUser();
  const roles = user?.realmRoles || [];
  const { t } = useTranslation('errors');
  const { logout } = useLogout();

  return roles.includes(ACCESS_DEMAND_PLANNING_ROLE) ? (
    children
  ) : (
    <BrandSidebarWithHeader>
      <ErrorSection
        code={403}
        title={t('Forbidden')}
        description={t('You are not authorized to access this app')}
        action={<Button onClick={() => void logout()}>{t('Logout')}</Button>}
      />
    </BrandSidebarWithHeader>
  );
}
